import React, { createContext, useContext } from "react";
import languages from "../_metronic/layout/components/extras/languages.json"; // now just { en: {...} }
import { loadCachedTranslations } from "../_metronic/_partials/utilities/remoteTranslations";

const LanguageContext = createContext(languages.en);

export function LanguageProvider({ value, children }) {
    return (
        <LanguageContext.Provider value={value || languages.en}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext) || languages.en;
}

// helper: wherever you currently build `value` for LanguageProvider,
// call this instead of `languages[lang]`
export function getLanguageValue(lang) {
    if (!lang) lang = "en";
    const cached = loadCachedTranslations();
    const remote = cached?.[lang];
    return { ...languages.en, ...(remote || {}) };
}

export default LanguageContext;